import React from 'react';

import { ConversionActions, ConversionContext } from '@contexts/index';

export function useConversion() {
  const context = React.useContext(ConversionContext);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined) {
    throw new Error(`useConversion must be used within a ConversionProvider`);
  }

  const { state, dispatch } = context;

  const convert = (props: { toggleType: string }) => {
    dispatch({ type: ConversionActions.ToggleConversion, ...props });
  };

  return { state, dispatch, convert };
}
